"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5201],{

/***/ 15201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50056);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15313);
/* harmony import */ var redux_api_reselect_billing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3411);
/* harmony import */ var theme_content_loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52005);
/* harmony import */ var theme_payment_account_card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42813);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5799);
/* harmony import */ var theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25733);
/* harmony import */ var theme_icons_plus__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26398);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99408);
/* harmony import */ var theme_alert_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(72846);
/* harmony import */ var theme_card__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16850);
/* eslint-disable no-nested-ternary */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 2100px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: ",
        "px 0;\n  padding: ",
        "px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  overflow: auto;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 220px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var Section = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b37b1c1c-0"
})(_templateObject());
var Row = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b37b1c1c-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .flexbox */ .GQ);
var CardsContainer = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b37b1c1c-2"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("space.m"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("space.s"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_100"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .layout */ .bK);
var WrapEmpty = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b37b1c1c-3"
})(_templateObject3());
function PaymentAccounts(param) {
    var selected = param.selected, errors = param.errors, noTotal = param.noTotal, onCardClick = param.onCardClick, onClickNew = param.onClickNew, edit = param.edit, company = param.company;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var isWaiting = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.billing;
    }).isWaiting;
    var payload = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(redux_api_reselect_billing__WEBPACK_IMPORTED_MODULE_7__/* .selectPaymentAccounts */ .ur);
    var handleOnClickNew = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (onClickNew) return onClickNew();
        return push("/billing/payment-account");
    }, [
        onClickNew,
        push
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Section, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "grey_600",
                                children: translations__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z[languageCode]["Payment methods"]
                            }),
                            !noTotal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                pl: "xxs",
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "primary_400",
                                children: payload.total
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            label: translations__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z[languageCode]["Create new"],
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_plus__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}),
                            onClick: handleOnClickNew
                        })
                    })
                ]
            }),
            errors && (errors.paymentAccountPid || errors.countryCode) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_card__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    width: "100%",
                    borderColor: "orange_400",
                    bg: "accent_light",
                    p: "m",
                    my: "l",
                    children: Object.entries(errors).map(function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_alert_message__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            message: value
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardsContainer, {
                minHeight: "148px",
                children: isWaiting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_content_loader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    width: 808,
                    height: 148,
                    lines: [
                        {
                            x: 0,
                            y: 0,
                            rx: 5,
                            ry: 5,
                            width: 400,
                            height: 148
                        },
                        {
                            x: 408,
                            y: 0,
                            rx: 5,
                            ry: 5,
                            width: 400,
                            height: 148
                        }, 
                    ]
                }) : payload.paymentAccounts.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapEmpty, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        pl: "xxs",
                        fontSize: "pSmall",
                        lineHeight: "pSmall",
                        fontWeight: "normal",
                        color: "primary_600",
                        children: translations__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z[languageCode]["You don't have a “Payment Methods” yet"]
                    })
                }) : payload.paymentAccounts.map(function(paymentAccount) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_payment_account_card__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                        paymentAccount: paymentAccount,
                        selected: selected === paymentAccount.id,
                        errors: errors,
                        style: {
                            mr: "xs",
                            maxWidth: "400px",
                            border: selected === paymentAccount.id ? "2px solid" : "1px solid",
                            borderColor: selected === paymentAccount.id ? "primary_500" : "primary_200"
                        }
                    }, paymentAccount), {
                        languageCode: languageCode,
                        onClick: onCardClick,
                        edit: edit,
                        company: company
                    }), paymentAccount.id);
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaymentAccounts);


/***/ }),

/***/ 26398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Plus(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width || "18",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 10.2271H10V16.2271H8V10.2271H2V8.22705H8V2.22705H10V8.22705H16V10.2271Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Plus);


/***/ }),

/***/ 42813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15313);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5799);
/* harmony import */ var theme_icons_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64740);
/* harmony import */ var theme_icons_check__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73377);
/* harmony import */ var theme_icons_check_circle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53107);
/* harmony import */ var react_circle_flags__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9765);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5434);
/* harmony import */ var theme_icons_payments_paypal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73407);
/* harmony import */ var theme_icons_payments_ababank__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92580);
/* harmony import */ var theme_icons_payments_bank__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84378);
/* harmony import */ var theme_icons_payments_sepa__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90350);
/* harmony import */ var theme_icons_payments_sureremit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81029);
/* harmony import */ var redux_api_action_billing__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(52947);
/* harmony import */ var theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25733);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99408);
/* eslint-disable no-nested-ternary */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  min-width: 390px;\n  min-height: 148px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 16px 16px 16px 32px;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 22px;\n  height: 22px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  bottom: -24px;\n  right: -24px;\n  transform: rotate(45deg);\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -2px;\n  right: 2px;\n  color: #fff;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 10px;\n  width: 16px;\n  height: 16px;\n  border-radius: 16px;\n  background-color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ::after {\n    content: '';\n    width: 12px;\n    height: 12px;\n    border-radius: 12px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: ",
        "px;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





















var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .border */ .Cg, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .layout */ .bK);
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .flexbox */ .GQ, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .position */ .FK);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(theme_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2614c667-2"
})(_templateObject2());
var StyledCircleFlag = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(react_circle_flags__WEBPACK_IMPORTED_MODULE_11__/* .CircleFlag */ .V).withConfig({
    componentId: "sc-2614c667-3"
})(_templateObject3());
var SelectedStatus = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-4"
})(_templateObject4(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .color */ .$_);
var WrapIcon = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-5"
})(_templateObject5());
var CircleStatus = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-6"
})(_templateObject6(), function(param) {
    var valid = param.valid;
    return !valid ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.grey_100") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.primary_100");
}, function(param) {
    var valid = param.valid;
    return !valid ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.grey_200") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.primary_400");
});
var VerifiedStatus = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-7"
})(_templateObject7(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("space.s"), function(param) {
    var verified = param.verified;
    return verified ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.primary_400") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.red_400");
});
function PaymentAccountCard(param) {
    var paymentAccount = param.paymentAccount, id = param.id, style = param.style, label = param.label, paymentMethodCode = param.paymentMethodCode, billingProfilesCounter = param.billingProfilesCounter, onClick = param.onClick, selected = param.selected, errors = param.errors, company = param.company, verified = param.verified;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var payee = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.billing;
    }).payee;
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var payeeResponse = payee.response;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!!(errors && (errors.paymentAccountPid || errors.countryCode))), errorPaymentCoerence = ref[0], setErrorPaymentCoerence = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (paymentAccount.paymentMethodCode === "PAYONEER") {
            dispatch((0,redux_api_action_billing__WEBPACK_IMPORTED_MODULE_20__/* .checkPayeeIdRequest */ .j9)({
                payeeId: paymentAccount.payoneer
            }));
        }
    }, [
        dispatch,
        paymentAccount
    ]);
    var paymentIcon = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        switch(paymentMethodCode){
            case "PAYPAL":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_paypal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {});
            case "ABA":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_ababank__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {});
            case "BANK":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_bank__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {});
            case "PAYONEER":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/images/logo_payoneer.png",
                    width: "64",
                    height: "35",
                    alt: "logo"
                });
            case "SEPA":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_sepa__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {});
            case "SURE_REMIT":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_sureremit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {});
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {});
        }
    }, [
        paymentMethodCode
    ]);
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (onClick) {
            setErrorPaymentCoerence(false);
            return onClick(id);
        }
        return push({
            pathname: "/billing/summary-payment-account",
            query: {
                id: id
            }
        });
    }, [
        push,
        onClick,
        id,
        company,
        paymentMethodCode
    ]);
    var handleEdit = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return push({
            pathname: "/billing/payment-account",
            query: {
                id: id
            }
        });
    }, [
        push,
        id
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({
        bg: "white"
    }, style), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Flex, {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                    flexDirection: "row",
                    alignItems: "center",
                    children: [
                        paymentIcon,
                        paymentAccount.paymentMethodCode === "PAYONEER" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircleStatus, {
                            valid: payeeResponse
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                            mx: "s",
                            flexDirection: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                                    mt: "xxs",
                                    color: billingProfilesCounter > 0 ? "grey_600" : "grey_200",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_user__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                                    ml: "xxs",
                                    fontSize: "pLarge",
                                    lineHeight: "pLarge",
                                    fontWeight: "bold",
                                    color: billingProfilesCounter > 0 ? "grey_600" : "grey_200",
                                    children: billingProfilesCounter
                                })
                            ]
                        }),
                        !!paymentAccount.countryCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCircleFlag, {
                            countryCode: paymentAccount.countryCode.toLowerCase()
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VerifiedStatus, {
                            verified: verified !== false,
                            children: verified === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_23__/* .MdBlock */ .a7d, {
                                size: 18,
                                title: "Not verified"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_check_circle__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                            flexDirection: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    label: verified === false ? translations__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z[languageCode].Verify : translations__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z[languageCode].Select,
                                    style: {
                                        minWidth: "auto"
                                    },
                                    onClick: handleClick,
                                    disabled: selected
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    label: translations__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z[languageCode].Edit,
                                    style: {
                                        minWidth: "auto"
                                    },
                                    onClick: function() {
                                        return handleEdit();
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                mt: "xs",
                fontSize: "h3",
                lineHeight: "h3",
                fontWeight: "bold",
                color: "grey_600",
                children: label
            }),
            paymentAccount.ownerName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                my: "xs",
                fontSize: "h3",
                lineHeight: "h3",
                fontWeight: "medium",
                color: "grey_400",
                children: paymentAccount.ownerName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectedStatus, {
                display: selected || errorPaymentCoerence ? "block" : "none",
                bg: selected && !errorPaymentCoerence ? "primary_500" : selected && errorPaymentCoerence ? "red_500" : "transparent"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapIcon, {
                children: selected && !errorPaymentCoerence ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_check__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    width: "14"
                }) : selected && errorPaymentCoerence ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_23__/* .MdError */ .vVM, {
                    width: "14"
                }) : ""
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (PaymentAccountCard);


/***/ })

}]);